import { useMemo } from 'react';
import { Button } from '@heroui/react';
import { Link } from 'react-router-dom';
import {
  TeacherAssignmentStats,
  TeacherAssignmentInfo,
  normalizeTeacherAssignmentInfoFromDetails,
} from '@/widgets/TeacherAssignments';
import { ITeacherAssignmentDetailsItem } from '@/entities/TeacherAssignment';
import { Svg } from '@/shared/ui/Svg';
import ArrowRightIcon from '@/shared/assets/icons/arrow-right-up.svg';
import { LessonTypeEnum } from '@/shared/types/lesson';;

interface TeacherAssignmentItemProps {
  item: ITeacherAssignmentDetailsItem;
}

export const TeacherAssignmentItem = ({ item }: TeacherAssignmentItemProps) => {
  const { lesson } = item;
  const isRegularLesson = lesson.type === LessonTypeEnum.Regular;

  // Generate link for assignment
  const assignmentLink = lesson.groupLessonId
    ? `/teacher/assignments/group-lesson/${lesson.groupLessonId}`
    : lesson.groupExamResubmissionId
      ? `/teacher/assignments/group-exam-resubmission/${lesson.groupExamResubmissionId}`
      : '#';

  const normalizedInfo = useMemo(() => normalizeTeacherAssignmentInfoFromDetails(item), [item]);
  const hasAssignment = lesson.assignmentId !== null;

  return (
    <div className="flex flex-col gap-y-4 p-6 bg-[#F9FAFB] rounded-[16px]">
      <TeacherAssignmentInfo data={normalizedInfo} />
      <TeacherAssignmentStats
        completed={item.totalCompleted}
        total={item.totalStudents}
        {...(isRegularLesson ? {} : { averageScore: lesson.assignmentInfo.averageGrade ?? 0 })}
      />

      {hasAssignment && (
        <div className="flex justify-end">
          <Button
            as={Link}
            to={assignmentLink}
            className="bg-[#211D55] text-white px-6"
            radius="full"
            endContent={<Svg Icon={ArrowRightIcon} className="w-4 h-4" />}
          >
            Open assignment
          </Button>
        </div>)}
    </div>
  );
};
